import firebase from 'firebase/app'
import 'firebase/firestore'

let config = {
  apiKey: 'AIzaSyC4BlY8ep7XpgZCaNB3LZWPo71s3F0LGfk',
  authDomain: 'pokerlab-ranges-v2.firebaseapp.com',
  databaseURL: 'https://pokerlab-ranges-v2.firebaseio.com',
  projectId: 'pokerlab-ranges-v2',
  storageBucket: 'pokerlab-ranges-v2.appspot.com',
  messagingSenderId: '1050668077808'
}

let app = firebase.initializeApp(config)

const firestore = firebase.firestore()
const settings = { timestampsInSnapshots: true }
firestore.settings(settings)

export const db = app.firestore()
